<template>
  <div class="linkItemDv">
    <IconComponent
      class="iconnotinfoDv"
      @click.stop="onRemove()"
      @touchstart="onRemove()"
      :id="`minusWining${index}`"
      v-if="showRemove"
      icon="minus.svg"
    />
    <div class="firstdv" v-if="favIcon">
      <figure>
        <img
          :src="`https://www.google.com/s2/favicons?domain=${trade.link}`"
          alt="Icon here."
        />
      </figure>
    </div>
    <div class="textDv">
      <el-tooltip
        class="box-item"
        effect="dark"
        placement="top-start"
        :content="trade.title"
        v-if="isOverflowing"
      >
        <h1 ref="title">{{ trade.title }}</h1>
      </el-tooltip>
      <h1 v-else ref="title">{{ trade.title }}</h1>

      <div class="iconinfoDv" @click="openURL()">
        <p ref="url">
          {{ sharingUrl }}
        </p>
        <IconComponent class="iconLinkDv" icon="icon-link.svg" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  onMounted,
  ref,
  watch,
  nextTick,
  computed,
} from "vue";
import IconComponent from "@/components/IconComponent.vue";

export default defineComponent({
  props: {
    fromPopup: Boolean,
    trade: Object,
    showRemove: Boolean,
    index: Number,
  },
  components: {
    IconComponent,
  },

  setup(props, context) {
    const sharingUrl = ref("");

    const isOverflowing = ref(false);
    const title = ref<HTMLElement | null>(null);
    const isUrlOverflowing = ref(false);
    const url = ref<HTMLElement | null>(null);
    const favIcon = ref(null);

    const getFavIcon = async () => {
      try {
        const img = await fetch(
          `https://www.google.com/s2/favicons?domain=${props?.trade?.link}`
        );

        return img;
      } catch (error) {
        return false;
      }
    };

    const checkOverflow = () => {
      nextTick(() => {
        if (title.value) {
          isOverflowing.value =
            title.value.scrollWidth > title.value.clientWidth;
        }
      });
    };

    const checkSymbolOverflow = () => {
      nextTick(() => {
        if (url.value) {
          isUrlOverflowing.value =
            url.value.scrollWidth > url.value.clientWidth;
        }
      });
    };

    const openURL = () => {
      if (props.fromPopup) {
      } else {
        window.open(`${props!.trade!.link}`, "_blank");
      }
    };

    const extractDomain = (url: any) => {
      let hostname;
      if (url.indexOf("//") > -1) {
        hostname = url.split("/")[2];
      } else {
        hostname = url.split("/")[0];
      }
      hostname = hostname.split(":")[0];
      hostname = hostname.split("?")[0];
      if (hostname.startsWith("www.")) {
        hostname = hostname.slice(4);
      }
      return hostname;
    };

    onMounted(async () => {
      sharingUrl.value = "";
      sharingUrl.value = extractDomain(props!.trade!.link);
      checkOverflow();
      checkSymbolOverflow();
      favIcon.value = (await getFavIcon()) as any;
    });

    watch(props, () => {
      sharingUrl.value = "";
      sharingUrl.value = extractDomain(props!.trade!.link);
      favIcon.value = getFavIcon() as any;
    });

    const onRemove = () => {
      context.emit("onRemove");
    };

    return {
      openURL,
      onRemove,
      sharingUrl,
      isOverflowing,
      title,
      isUrlOverflowing,
      url,
      favIcon,
    };
  },
});
</script>

<style lang="scss" scoped>
.linkItemDv {
  background: var(--base-light);
  border-radius: 10px;
  position: relative;
  cursor: pointer;
  box-shadow: -2px 3px 18px 0px rgba(75, 70, 92, 0.1);
  padding: 10px 10px;
  display: flex;
  min-height: 70px;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;

  .firstdv {
    height: 50px;
    display: flex;
    align-items: flex-start;

    figure {
      width: 25px;
      height: 25px;
      margin: 5px 0px 0px;
      padding: 0px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        vertical-align: middle;
        border-radius: 50%;
      }
    }
  }

  .textDv {
    overflow: hidden;
    width: 100%;

    h1 {
      font-size: var(--font-2md);
      line-height: 1.3;
      letter-spacing: 0px;
      padding: 0px;
      margin: 0px 0px 0px;
      color: var(--text-color);
      font-weight: 600;
      text-align: left;
      white-space: nowrap !important;
      overflow: hidden !important;
      text-overflow: ellipsis !important;
    }

    .iconinfoDv {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 10px;
      margin: 2px 0px 0px;

      p {
        font-size: var(--font-2sm);
        letter-spacing: 0px;
        padding: 0px;
        margin: 0px 0px 0px;
        color: var(--blue);
        white-space: nowrap !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        font-weight: 400;
        text-align: left;
      }

      .iconLinkDv {
        width: 20px;
        flex: 0 0 20px;
        height: 20px;
        opacity: 0.6;
        color: var(--base-text);
      }
    }
  }

  .iconnotinfoDv {
    width: 18px;
    height: auto;
    right: -5px;
    top: -5px;
    cursor: pointer;
    position: absolute;
    z-index: 9;
  }
}

@media screen and (min-width: 1280px) and (max-width: 1891px) {
  .linkItemDv {
    min-height: 56px;

    .textDv {
      h1 {
        font-size: var(--font-1xs);
      }

      .iconinfoDv {
        margin-top: 0;

        .iconLinkDv {
          max-width: 15px;
          flex: 0 0 15px;
        }

        p {
          font-size: var(--font-2xs);
        }
      }

      p {
        font-size: var(--font-2xs);
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .linkItemDv {
    .textDv {
      h1 {
        font-size: var(--font-xs);
      }

      p {
        font-size: var(--font-2xs);
      }
    }
  }
}
</style>
